import { TextAlignProperty } from 'csstype';

export enum InputTypeEnum {
	TEXT = 'text',
	PASSWORD = 'password',
	TEXTAREA = 'textarea',
}

export interface IInput {
	onChange?: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
	onFocus?: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
	onBlur?: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
	width?: string;
	placeholder?: string;
	type?: InputTypeEnum;
	value?: string;
	defaultValue?: string;
	dataTestId?: string;
	isDisabled?: boolean;
	hasError?: boolean;
	errorMessage?: string;
	onSuccess?: boolean;
	name?: string;
	tooltipText?: string;
	forPassword?: boolean;
	label?: string;
	description?: string;
	required?: boolean;
	pattern?: string;
	textAlign?: TextAlignProperty;
}
